import { render, staticRenderFns } from "./NewGame.vue?vue&type=template&id=b6a35a22&scoped=true"
import script from "./NewGame.vue?vue&type=script&lang=js"
export * from "./NewGame.vue?vue&type=script&lang=js"
import style0 from "./NewGame.vue?vue&type=style&index=0&id=b6a35a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a35a22",
  null
  
)

export default component.exports